import styled from "styled-components";
import { Theme } from "../../../../@types/theme";

export const FlexSearch = styled.div`
  width: 100%;
  height: 60px;
  margin-top: 2rem;
  margin-bottom: -1rem;
`;

export const Heading = styled.div`
  font-size: 1.8rem;
  margin: 1.8rem 0 1.8rem 1.6rem;
  color: ${({ theme }: Theme) => theme.colors.black};

  @media (max-width: 1600px) {
    font-size: 1.6rem;
    margin: 1.8rem 0 1.5rem 1.6rem;
  }

  @media (max-width: 1366px) {
    font-size: 1.5rem;
    margin: 1.8rem 0 1.3rem 1.6rem;
  }
`;
